import router from '@/router'
export default {
    namespaced: true,
    state: {
        data: null,
    },
    getters: {

    },
    mutations: {

    },
    actions: {

    },
}
